import { FindJobsQuery } from 'jobs/dtos/job'
import JobSearchStore, {
  JobSearchEvent,
} from 'jobs/views/JobManagement/JobSearchStore'
import { JobSearchPorts } from 'jobs/views/JobManagement/ports'
import { Observable } from 'rxjs'

export default class JobSearchAdapter implements JobSearchPorts {
  events$: Observable<JobSearchEvent>

  constructor(private jobSearchStore: JobSearchStore) {
    this.events$ = this.jobSearchStore.jobEvents$
  }

  async searchJobs(query: FindJobsQuery) {
    return this.jobSearchStore.searchJobs(query)
  }

  async getTotal(query: FindJobsQuery) {
    return this.jobSearchStore.getTotal(query)
  }
}
